<template>
    <span>
        <v-btn icon class="mx-0" @click="deletecam()">
                      <v-icon color="pink">delete</v-icon>
          </v-btn>
           <v-snackbar v-model="show" color="success">{{message}}</v-snackbar>
   
            </span>
</template>

<script>
import {deleteModuleWithAttachment} from '@/model';
import moment from 'moment';

export default {
    name: 'DeleteCampus',
    props:{
        name :{
            required:true
        }
    },
    data() {
        return {
           show:false,
           message:'',
         
        };
    },
    methods: {
        deletecam() {
            let self=this;
            let confirmed =  confirm('Warning!!! \n This will delete all movies linked to this campus, do you continue?','Exodus','Yes','No');
    
            if(confirmed){
            
            let datenow = moment().format('DD/MM/YYYY');
            console.log(datenow);
            
            
            deleteModuleWithAttachment('campus',this.name,function(response){
              if(response){
                    console.log("This is response: ",response);
                    self.message = "This has been successfully deleted";
                    self.show=true; 
                   self.$store.dispatch('updateCampus',true);
                                       
                  }else{
                      console.log(null);
                  }

              });

                          }
        }
    }
};
</script>

<style scoped>
</style>